<app-system-message></app-system-message>
@if (loadingPage) {
  <app-loading-element class="bin-update-loading-overlay"></app-loading-element>
}
<!-- Container for the form with dynamic styling -->
<div [ngClass]="theme.getThemeClass()" class="container-fluido" [class.d-none]="loadingPage">
  <section [ngClass]="theme.getThemeClass()" class="card bg-light">
    <article class="card-body mx-auto article">
      <h4 class="card-title mt-0 text-center">{{ 'binUpdateViewBinUpdate' | translate }}</h4>
      <form>
        <!-- BIN NAME -->
        <label class="label-spacer">{{ "binName" | translate }}  </label>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-dumpster"></i></span>
          <input
            [(ngModel)]="this.bin.bin_data.bin_name"
            id="binName"
            type="text" class="form-control" name="bin_name"
            value="{{ this.bin.bin_data.bin_name }}"
            >
        </div>
        <!-- BIN MODEL -->
        <label class="label-spacer">{{ "binModel" | translate }} <span class="requiredStar">*</span></label>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"><i class="fa fa-hashtag"></i></span>
          <select
            [(ngModel)]="this.bin.bin_data.bin_model_id"
            id="binSelect"
            class="form-control"
            name="binSelect"
            aria-label="Bin_model_number"
            (change)="binModelChange()"
            [ngClass]="{ 'has-value': this.bin.bin_data.bin_model_id }"
            [disabled]="isReadOnly()"
          >
            <option value="">{{ 'binSelectOptionSelectBinModel' | translate }}</option>
            @for (model of this.bin.bin_model_array; track model.bin_model_id) {
              <option [value]="model.bin_model_id">{{ model.bin_model_number }}</option>
            }
          </select>
        </div>
        <!-- BIN USAGE -->
        <label class="label-spacer">{{ "adminViewBinUsageNavBar" | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1"><i class="fa fa-trash"></i></span>
                  <select
                    class="form-control ng-select"
                    name="binUsage"
                    [(ngModel)]="this.bin.bin_data.bin_usage"
                    aria-label="Bin usage"
                    aria-describedby="basic-addon1"
                    (blur)="this.validationService.validateBinUsage(this.bin.bin_data.bin_usage)"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'binUsageError'"
                  >
                    <option value="">{{ 'adminViewBinUsageNavBar' | translate }}</option>
                    @for (usage of binUsage; track usage.value) {
                      <option [value]="usage.value">{{ usage.label | translate }}</option>
                    }
                  </select>
              </div>
        <!-- MARKET SEGMENT -->
        <label class="label-spacer">{{ "marketSegment" | translate }} </label>
        <div class="input-group mb-3 firstInput">
          <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-thumbtack"></i></span>
          <select
            [(ngModel)]="this.bin.bin_data.market_segment"
            [ngClass]="{ 'has-value': this.bin.bin_data.market_segment }"
            id="marketSelect"
            class="form-control"
            name="marketSelect"
            aria-label="bin_market_segment"
            aria-describedby="basic-addon1"
          >
            <option value="">{{ 'marketSegment' | translate }}</option>
            @for (segment of marketSegmentOptions; track segment.value) {
              <option [value]="segment.value">{{ segment.label | translate }}</option>
            }
          </select>
        </div>
        <!-- Input field for address with Autocomplete -->
        <label class="label-spacer">{{ "usereditFormLabelAddress" | translate }} <span class="requiredStar">*</span></label>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"><i class="fas fa-search-location"></i></span>
          <input id="autocomplete" [(ngModel)]="this.bin.bin_data.bin_address" (keydown)="onInputAddressKeydown($event);"
            type="text" class="form-control" name="bin_location"
            placeholder="{{ 'clientcreateFormInputFindAddress' | translate }}">
        </div>

        <!-- BIN GPS -->
        <label class="label-spacer">{{ "Latitude" | translate }} </label>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-location-crosshairs"></i></span>
          <input
            [(ngModel)]="this.latitude"
            id="binLatitude"
            type="number"
            class="form-control"
            name="bin_latitude"
            value="{{ latitude }}"
            placeholder="{{ 'Latitude' | translate }}"
          >
        </div>

        <label class="label-spacer">{{ "Longitude" | translate }} </label>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-location-crosshairs"></i></span>
          <input
            [(ngModel)]="this.longitude"
            id="binLongitude"
            type="number"
            class="form-control"
            name="bin_longitude"
            value="{{ longitude }}"
            placeholder="{{ 'Longitude' | translate }}"
          >
        </div>
          <!-- Select used to get put an association between bin and client -->
          @if (this.cognitoService.userType === 'muirwood' || this.cognitoService.userType === 'distributor') {
          <div>
            <label class="label-spacer">{{ "clientName" | translate }} <span class="requiredStar">*</span></label>
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1"><i class="fas fa-briefcase"></i></span>
              <select
                [(ngModel)]="this.bin.bin_data.client_id"
                class="form-control"
                name="client"
                [ngClass]="{ 'has-value': this.bin.bin_data.client_id }"
                aria-label="Client Name"
                aria-describedby="basic-addon1"
                (change)="selectedClientChange()"
              >
                <option value="">{{ 'devicecreateSelectClient' | translate }}</option>
                @for (option of clientOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </div>
          </div>
          }
          <!-- Select used to get put an association between bin/client/thing -->
          @if (this.bin.isDeviceArray) {
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-microchip"></i></span>
            <select
              [(ngModel)]="this.thing_name"
              class="form-control"
              name="thing"
              aria-label="thing_name"
              aria-describedby="basic-addon1"
              [ngClass]="{ 'has-value': this.thing_name }"
            >
              <option value="">{{ 'iotModalViewDeviceName' | translate }}</option>
              @for (option of deviceOptions; track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
          }
        <!-- Input for the threshold -->
        <label class="label-spacer">{{ "alertThreshold" | translate }} <span class="requiredStar">*</span></label>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"><i class="fa-regular fa-bell"></i></span>
          <input [(ngModel)]="this.bin.bin_data.threshold" type="number"
          class="form-control" name="threshold" aria-label="bin_depth" (change)="thresholdChange()">
        </div>

        <!-- Input for the device attached -->
        <label class="label-spacer">{{ "assignedDevice" | translate }}</label>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-microchip tile-icon device-icon"></i></span>
          <select
            [(ngModel)]="this.bin.bin_data.thing_name"
            #deviceAttached
            class="form-control ng-select"
            name="thing"
            aria-label="thing Name"
            aria-describedby="basic-addon1"
            [disabled]="loadingDevices"
          >
            <option value="this.bin.bin_data.thing_name" selected disabled>{{ "deviceSelectBinUpdate" | translate }}</option>
            @for (option of this.availableDevices; track option) {
              <option [ngValue]="option">{{ option }}</option>
            }
          </select>
        </div>
        @if (loadingDevices) {
          <app-loading-element class="bin-update-loading-overlay"></app-loading-element>
        }

        <!-- Checkbox for the status -->
        <!-- <div class="card-title mt-0 status">
            <label class="switch">
                <input type="checkbox" id="checkboxStatus" [name]="'active-bin-' + bin.bin_data.bin_id" [ngModel]="bin.bin_data.active" (change)="this.alert.showAlertDelete= true; this.alert.deactiveBin(bin.bin_data.bin_id, bin.bin_data.bin_address, bin.bin_data.active)" [disabled]="this.alert.showAlertDelete">
                <span [ngClass]="{'active-checkbox': bin.bin_data.active === 1, 'inactive-checkbox': bin.bin_data.active === 0}"  class="slider round"></span>
            </label>
            <label class="toggle">{{ "iotTabHeaderStatus" | translate }}</label>
        </div> -->
          <!-- Configuration option for Auto Update (currently unused)
          <div class="card-title mt-0 status">
            @if (this.bin.bin_data.thing_name) {
              <label class="switch">
                <input
                  type="checkbox"
                  id="checkboxAutoUpdate"
                  [name]="'auto-update'"
                  [(ngModel)]="autoUpdate"
                >
                <span
                  [ngClass]="{
                    'active-checkbox': this.iotService.thingShadow.state.desired.config.upf === 1,
                    'inactive-checkbox': this.iotService.thingShadow.state.desired.config.upf === 0
                  }"
                  class="slider round"
                ></span>
              </label>
              <label class="toggle">{{ "autoUpdate" | translate }}</label>
            }
          </div>
          -->
        <!-- Submit button -->
        <nav class="form-group displayFlex">
            @if (this.cognitoService.userType === 'muirwood' && !this.redirectToCLientDeviceList) {
            <button (click)="returnToAdmin()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
            }
            @if (this.cognitoService.userType === 'client' && !this.redirectToCLientDeviceList) {
            <button (click)="returnClientBinList()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
            }
            @if (this.cognitoService.userType === 'distributor' && !this.redirectToCLientDeviceList) {
            <button (click)="returnDistributorBinList()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
            }

            @if (this.redirectToCLientDeviceList) {
            <button (click)="returnDeviceClientList()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
            }
            <button [ngClass]="theme.getThemeClass()" (click)="onSubmit()" type="button" class="btn btn-block btnCreate">{{ 'update' | translate }}</button>
        </nav>
      </form>
    </article>
    @if (this.alert.showAlertDelete) {
    <app-alert-modal class="alertDelete" [ngClass]="theme.getThemeClass()"></app-alert-modal>
    }
  </section>
</div>
